const { REGISTER_BIKE_URL } = require("./urls")

const ROUTE_REDIRECTS = {
  "/apps/product-registration": REGISTER_BIKE_URL,
}

const getRouteRedirect = (pathname) => ROUTE_REDIRECTS[pathname] || null

module.exports = {
  ROUTE_REDIRECTS,
  getRouteRedirect,
}
